/**
 * Represents a role with its basic information.
 */
export interface RolesModel {
  /** Unique identifier for the role */
  id: string;
  /** Name of the role */
  name: string;
  /** Identifier for the parent role, if available */
  parent_id?: string;
  /** Key of the role */
  key?: string;
}

/**
 * Enum representing different types of roles.
 */
export enum RolesTypeEnum {
  /** Administrator role */
  Admin = "admin",
  /** Manager role */
  Manager = "manager",
  /** ADler role */
  ADler = "adler_iw",
  /** IDler role */
  IDler = "idler_iw",
  /** STler role */
  STler = "stler",
  /** Client role */
  Client = "client",
  /** Client worker role */
  ClientWorker = "client_worker",
  /** ADler TW role */
  ADlerTW = "adler_tw",
  /** IDler TW role */
  IDlerTW = "idler_tw",
  /** Client unpaid role */
  ClientUnpaid = "client_unpaid",

  ClientManager = "client_manager",
}
